import { DesignSystemToken, StringTokenValue } from 'designSystem/types';
import { resolvesToColor } from './tokenUtil';
import { BorderRadiusTokenPreview } from './BorderRadiusTokenPreview';
import { ColorTokenPreview } from './ColorTokenPreview';
import { FontFamilyTokenPreview } from './FontFamilyTokenPreview';
import { FontSizeTokenPreview } from './FontSizeTokenPreview';
import { FontWeightTokenPreview } from './FontWeightTokenPreview';
import { LengthTokenPreview } from './LengthTokenPreview';
import { LineHeightTokenPreview } from './LineHeightTokenPreview';
import { OpacityTokenPreview } from './OpacityTokenPreview';
import { OtherTokenPreview } from './OtherTokenPreview';
import { ShadowTokenPreview } from './ShadowTokenPreview';
import { SpacingTokenPreview } from './SpacingTokenPreview';
import { StylesColorTokenPreview } from './StylesColorTokenPreview';
import { TransitionTokenPreview } from './TransitionTokenPreview';

interface TokenPreviewProps {
	token: DesignSystemToken;
}

// Renders the appropriate preview for a token based on its category and value kind.
// Shared between TokenCard (tile view) and TokenTable (list view).
const TokenPreview = ({ token }: TokenPreviewProps) => {
	if (token.category === 'spacing' && token.value.kind === 'length') {
		return <SpacingTokenPreview value={token.value} />;
	}

	const isColor = token.category === 'color' || resolvesToColor(token.value.original);
	if (token.value.kind === 'string' && isColor) {
		return <StylesColorTokenPreview value={token.value as StringTokenValue} />;
	}

	switch (token.value.kind) {
		case 'color':
			return <ColorTokenPreview value={token.value} />;
		case 'length':
			return <LengthTokenPreview value={token.value} />;
		case 'shadow':
			return <ShadowTokenPreview value={token.value} />;
		case 'fontFamily':
			return <FontFamilyTokenPreview value={token.value} />;
		case 'fontSize':
			return <FontSizeTokenPreview value={token.value} />;
		case 'lineHeight':
			return <LineHeightTokenPreview value={token.value} />;
		case 'fontWeight':
			return <FontWeightTokenPreview value={token.value} />;
		case 'borderRadius':
			return <BorderRadiusTokenPreview value={token.value} />;
		case 'opacity':
			return <OpacityTokenPreview value={token.value} />;
		case 'transition':
			return <TransitionTokenPreview value={token.value} />;
		case 'number':
		case 'string':
			return <OtherTokenPreview value={token.value} />;
		default:
			return <OtherTokenPreview value={token.value as any} />;
	}
};

export default TokenPreview;
